import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { menuLang } from "../../../lang/lang";
import InqueryModal from "../../../pages/modal/inqueryModal";
import { langState } from "../../../store/langState";
import { menuState } from "../../../store/menuState";
import PretendardText from "../../atoms/text/pretendardText";
import { routeV1 } from "../../../pages/(v1)/route.v1";

const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;

const MHeader = ({ isOpen, setMHeaderOpen }) => {
  const navigation = useNavigate();
  const { pathname } = useLocation();

  const menuAtom = useRecoilValue(menuState);

  const [language, setLanguage] = useRecoilState(langState);
  const [isSecondOpen, setIsSecondOpen] = useState(-1);
  const [isThirdOpen, setIsThirdOpen] = useState(-1);
  const [isFourthOpen, setIsFourthOpen] = useState(-1);

  const [isInqueryModal, setIsInqueryModal] = useState(false);

  useEffect(() => {
    const getProductFunc = async () => {
      menuAtom?.forEach((item, index) => {
        if (pathname.includes(item.originLink)) {
          setIsSecondOpen(index);

          item.subMenus2?.forEach((item2, index2) => {
            if (pathname.includes(item2.originLink || item2.link)) {
              setIsThirdOpen(index2);

              item2.subMenus3?.forEach((item3, index3) => {
                if (pathname.includes(item3.originLink || item3.link)) {
                  setIsFourthOpen(index3);
                }
              });
            }
          });
        }
      });
    };
    getProductFunc();
  }, [
    language,
    menuAtom,
    pathname,
    setIsSecondOpen,
    setIsThirdOpen,
    setIsFourthOpen,
  ]);

  return (
    <>
      <MHeaderWrapper $isOpen={isOpen}>
        <MHeaderContainer>
          {/* top */}
          <div style={{ display: "flex", gap: "3rem" }}>
            <img
              src={`${S3_BASE_URL}/assets/icons/logo_black.png`}
              alt=""
              style={{ marginLeft: "20px", marginBottom: "25px" }}
            />
            <ChangeLangBtn
              onClick={() =>
                setLanguage((prev) => (prev === "KR" ? "EN" : "KR"))
              }
            >
              <MenuText
                className="custom-cursor"
                style={{
                  width: "20px",
                  fontSize: "15px",
                  fontWeight: 400,
                  lineHeight: "20.7px",
                  color: "#262C31",
                  letterSpacing: "-1%",
                }}
              >
                {language}
              </MenuText>
            </ChangeLangBtn>
          </div>
          {/* close */}
          <img
            src={`${S3_BASE_URL}/assets/icons/header_x.png`}
            alt=""
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              width: "15px",
            }}
            onClick={() => setMHeaderOpen(false)}
          />
          {/* menu */}
          <div>
            {menuAtom?.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  <MenuWrapper
                    $active={pathname.includes(item.originLink || item.link)}
                    onClick={() => {
                      if (item.subMenus2?.length > 0) {
                        // 하위 메뉴가 있으면 토글
                        if (isSecondOpen === index) {
                          setIsSecondOpen(-1);
                        } else {
                          setIsSecondOpen(index);
                        }
                        setIsThirdOpen(-1);
                        setIsFourthOpen(-1);
                      }
                    }}
                  >
                    <Menu
                      className="custom-cursor"
                      $active={pathname.includes(item.originLink || item.link)}
                      onClick={(e) => {
                        e.stopPropagation();
                        setMHeaderOpen(false);
                        navigation(item.link);
                      }}
                    >
                      {item.title.startsWith("MENU")
                        ? menuLang[item.title]?.[language] ?? item.title
                        : item.title}
                    </Menu>
                    {item.subMenus2?.length > 0 && (
                      <ArrowIcon
                        src={`${S3_BASE_URL}/assets/icons/header_arrow.png`}
                        alt=""
                        $isOpen={isSecondOpen === index}
                      />
                    )}
                  </MenuWrapper>

                  {/* second depth */}
                  <SecondDepthContainer
                    $isOpen={isSecondOpen === index && item.subMenus2}
                  >
                    {item.subMenus2 && (
                      <>
                        {item.subMenus2?.map((item2, index2) => {
                          if (item2.originLink && item2.subMenus3.length <= 0) {
                            return null;
                          }
                          if (item2.exposure === false) {
                            return null;
                          }

                          return (
                            <React.Fragment key={index2}>
                              <SecondMenuWrapper
                                $active={pathname.includes(
                                  item2.originLink || item2.link
                                )}
                                $isLast={index2 === item.subMenus2.length - 1}
                                onClick={() => {
                                  if (item2.subMenus3?.length > 0) {
                                    // 하위 메뉴가 있으면 토글
                                    if (isThirdOpen === index2) {
                                      setIsThirdOpen(-1);
                                    } else {
                                      setIsThirdOpen(index2);
                                    }
                                    setIsFourthOpen(-1);
                                  }
                                }}
                              >
                                <SecondMenu
                                  className="custom-cursor"
                                  $active={pathname.includes(
                                    item2.originLink || item2.link
                                  )}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setMHeaderOpen(false);
                                    navigation(item2.link);
                                  }}
                                >
                                  {item2.title.startsWith("MENU")
                                    ? menuLang[item2.title]?.[language] ?? item2.title
                                    : item2.title}
                                </SecondMenu>
                                {item2.subMenus3?.length > 0 ? (
                                  <ArrowIcon
                                    src={`${S3_BASE_URL}/assets/icons/header_arrow.png`}
                                    alt=""
                                    $isOpen={isThirdOpen === index2}
                                  />
                                ) : null}
                              </SecondMenuWrapper>

                              {/* third depth */}
                              <ThirdDepthContainer
                                $isOpen={
                                  isThirdOpen === index2 && item2.subMenus3
                                }
                              >
                                {item2.subMenus3 && (
                                  <>
                                    {item2.subMenus3?.map((item3, index3) => {
                                      if (
                                        item3.originLink &&
                                        item3.subMenus4.length <= 0
                                      ) {
                                        return null;
                                      }
                                      if (item3.exposure === false) {
                                        return null;
                                      }

                                      return (
                                        <React.Fragment key={index3}>
                                          <ThirdMenuWrapper
                                            $active={pathname.includes(
                                              item3.originLink || item3.link
                                            )}
                                            $isLast={
                                              index3 ===
                                              item2.subMenus3.length - 1
                                            }
                                            onClick={() => {
                                              if (item3.subMenus4?.length > 0) {
                                                // 하위 메뉴가 있으면 토글
                                                if (isFourthOpen === index3) {
                                                  setIsFourthOpen(-1);
                                                } else {
                                                  setIsFourthOpen(index3);
                                                }
                                              }
                                            }}
                                          >
                                            <ThirdMenu
                                              className="custom-cursor"
                                              $active={pathname.includes(
                                                item3.originLink || item3.link
                                              )}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setMHeaderOpen(false);
                                                navigation(item3.link);
                                              }}
                                            >
                                              {item3.title.startsWith("MENU")
                                                ? menuLang[item3.title]?.[
                                                    language
                                                  ] ?? item3.title
                                                : item3.title}
                                            </ThirdMenu>
                                            {item3.subMenus4?.length > 0 ? (
                                              <ArrowIcon
                                                src={`${S3_BASE_URL}/assets/icons/header_arrow.png`}
                                                alt=""
                                                $isOpen={
                                                  isFourthOpen === index3
                                                }
                                              />
                                            ) : null}
                                          </ThirdMenuWrapper>

                                          {/* fourth depth */}
                                          <FourthDepthContainer
                                            $isOpen={
                                              isFourthOpen === index3 &&
                                              item3.subMenus4
                                            }
                                          >
                                            {item3.subMenus4 && (
                                              <>
                                                {item3.subMenus4?.map(
                                                  (item4, index4) => {
                                                    if (
                                                      item4.exposure === false
                                                    ) {
                                                      return null;
                                                    }

                                                    return (
                                                      <FourthMenuWrapper
                                                        $active={pathname.includes(
                                                          item4.originLink ||
                                                            item4.link
                                                        )}
                                                        $isLast={
                                                          index4 ===
                                                          item3.subMenus4
                                                            .length -
                                                            1
                                                        }
                                                        key={index4}
                                                        onClick={() => {
                                                          setMHeaderOpen(false);
                                                          navigation(
                                                            item4.link
                                                          );
                                                        }}
                                                      >
                                                        <FourthMenu
                                                          className="custom-cursor"
                                                          $active={pathname.includes(
                                                            item4.originLink ||
                                                              item4.link
                                                          )}
                                                        >
                                                          {item4.title.startsWith(
                                                            "MENU"
                                                          )
                                                            ? menuLang[
                                                                item4.title
                                                              ]?.[language] ?? item4.title
                                                            : item4.title}
                                                        </FourthMenu>
                                                      </FourthMenuWrapper>
                                                    );
                                                  }
                                                )}
                                              </>
                                            )}
                                          </FourthDepthContainer>
                                        </React.Fragment>
                                      );
                                    })}
                                  </>
                                )}
                              </ThirdDepthContainer>
                            </React.Fragment>
                          );
                        })}
                      </>
                    )}
                  </SecondDepthContainer>
                </React.Fragment>
              );
            })}
          </div>
          {/* contact */}
          <ContactMenuWrapper
            onClick={() => {
              setMHeaderOpen(false);

              navigation(routeV1.tel);

              setTimeout(() => {
                const element = document.getElementById("tel");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }, 100);
            }}
          >
            <ContactMenu>CONTACT</ContactMenu>
          </ContactMenuWrapper>
        </MHeaderContainer>
      </MHeaderWrapper>
      {isInqueryModal ? <InqueryModal setVisiable={setIsInqueryModal} /> : null}
    </>
  );
};

export default MHeader;

const MHeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  /* overflow-y: auto; */
`;

const MHeaderContainer = styled.div`
  position: relative;
  width: 100vw;
  min-height: 100svh;
  background: #fff;
  z-index: 10;
  padding: 16px 0 50px 0;
`;

const MenuWrapper = styled.div`
  width: 100%;
  height: 63px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-top: 1px solid #d7dce2;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background-color: ${(props) => (props.$active ? "#00AEEF05" : "transparent")};

  &:hover {
    background-color: ${(props) => (props.$active ? "#00AEEF08" : "#f8f9fa")};
  }

  &:active {
    background-color: ${(props) => (props.$active ? "#00AEEF0a" : "#e9ecef")};
  }
`;

const Menu = styled(PretendardText)`
  font-weight: 400;
  font-size: 16px;
  line-height: 145%;
  color: ${(props) => (props.$active ? "#00AEEF" : "#5a636a")};
  cursor: pointer;
  transition: color 0.2s ease;
`;

const SecondMenuWrapper = styled.div`
  width: 100%;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 16px 30px;
  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #f1f1f1")};
  background-color: ${(props) => (props.$active ? "#00AEEF05" : "")};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.$active ? "#00AEEF08" : "#f8f9fa")};
  }

  &:active {
    background-color: ${(props) => (props.$active ? "#00AEEF0a" : "#e9ecef")};
  }
`;

const SecondMenu = styled(PretendardText)`
  font-weight: 400;
  font-size: 15px;
  line-height: 140%;
  color: ${(props) => (props.$active ? "#00AEEF" : "#5a636a")};
  cursor: pointer;
  transition: color 0.2s ease;
`;

const ThirdMenuWrapper = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px 15px 40px;
  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #f1f1f1")};
  background-color: ${(props) => (props.$active ? "#00AEEF05" : "")};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.$active ? "#00AEEF08" : "#f8f9fa")};
  }

  &:active {
    background-color: ${(props) => (props.$active ? "#00AEEF0a" : "#e9ecef")};
  }
`;

const ThirdMenu = styled(PretendardText)`
  font-weight: 400;
  font-size: 15px;
  line-height: 140%;
  color: ${(props) => (props.$active ? "#00AEEF" : "#778088")};
  cursor: pointer;
  transition: color 0.2s ease;
`;

const FourthMenuWrapper = styled.div`
  width: 100%;
  height: 49px;
  display: flex;
  align-items: center;
  padding: 15px 20px 15px 50px;
  border-bottom: ${(props) => (props.$isLast ? "none" : "1px solid #f1f1f1")};
  background-color: ${(props) => (props.$active ? "#00AEEF05" : "")};
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.$active ? "#00AEEF08" : "#f8f9fa")};
  }

  &:active {
    background-color: ${(props) => (props.$active ? "#00AEEF0a" : "#e9ecef")};
  }
`;

const FourthMenu = styled(PretendardText)`
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  color: ${(props) => (props.$active ? "#00AEEF" : "#778088")};
  cursor: pointer;
  transition: color 0.2s ease;
`;

const ContactMenuWrapper = styled.div`
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
  padding: 18px 20px;
  background-color: #f9f9f9;
  border-top: 1px solid #d7dce2;
`;

const ContactMenu = styled(PretendardText)`
  color: #00aeef;
  font-size: 15px;
  font-weight: 600;
  line-height: 140%;
`;

const ChangeLangBtn = styled.button`
  height: 30px;
  padding: 8px 15px;
  border-radius: 4px;
  border: 1px solid #d7dce2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
`;

const MenuText = styled(PretendardText)`
  font-weight: 400;
  font-size: 16px;
  line-height: 23.2px;
  color: #5a636a;
  /* cursor: pointer; */

  &:hover {
    color: #00aeef;
  }
`;

const SecondDepthContainer = styled.div`
  overflow: hidden;
  max-height: ${(props) => (props.$isOpen ? "500px" : "0")};
  opacity: ${(props) => (props.$isOpen ? "1" : "0")};
  transform: ${(props) =>
    props.$isOpen ? "translateY(0)" : "translateY(-10px)"};
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.3s ease-out 0.1s, transform 0.3s ease-out 0.1s;
`;

const ThirdDepthContainer = styled.div`
  overflow: hidden;
  max-height: ${(props) => (props.$isOpen ? "400px" : "0")};
  opacity: ${(props) => (props.$isOpen ? "1" : "0")};
  transform: ${(props) =>
    props.$isOpen ? "translateY(0)" : "translateY(-8px)"};
  transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.25s ease-out 0.08s, transform 0.25s ease-out 0.08s;
`;

const FourthDepthContainer = styled.div`
  overflow: hidden;
  max-height: ${(props) => (props.$isOpen ? "300px" : "0")};
  opacity: ${(props) => (props.$isOpen ? "1" : "0")};
  transform: ${(props) =>
    props.$isOpen ? "translateY(0)" : "translateY(-6px)"};
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.2s ease-out 0.06s, transform 0.2s ease-out 0.06s;
`;

const ArrowIcon = styled.img`
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`;
